<template>
  <div>
    <div class="text-center mb-3">
      <img :src="`${app.logo}?tr=h-125`" class="logo" />
    </div>
    <div class="card" :class="$style.container">
      <h3> Please verify your details </h3>
      <a-form :form="form" class="mt-2">
        <a-form-item label="Email">
          <div class="text-muted">
            Please click on the verification link that we just sent to your inbox to verify your Email ID
          </div>
          <a style="color: blue;" href="#" @click.prevent="resendEmail"> Resend Email </a>
        </a-form-item>
        <a-tabs />
        <a-form-item label="Phone">
          <div class="text-muted">
            Please insert the OTP code that we just send to your phone number
          </div>
          <div class="d-flex justify-content-center">
            <input id="codeBox1" type="number" maxlength="1">
            <input id="codeBox2" type="number" maxlength="1">
            <input id="codeBox3" type="number" maxlength="1">
            <input id="codeBox4" type="number" maxlength="1">
            <input id="codeBox5" type="number" maxlength="1">
            <input id="codeBox6" type="number" maxlength="1">
          </div>
          <!-- <a-input-number :min="0" :max="9" class="mr-1" />
          <a-input-number :min="0" :max="9" class="mr-1" />
          <a-input-number :min="0" :max="9" class="mr-1" />
          <a-input-number :min="0" :max="9" class="mr-1" />
          <a-input-number :min="0" :max="9" class="mr-1" />
          <a-input-number :min="0" :max="9" class="mr-1" /> -->
        </a-form-item>
        <!-- <section> -->
          <!-- <form> -->
          <!-- </form> -->
        <!-- </section> -->
        <a-button
          type="primary"
          size="large"
          class="text-center w-100"
          htmlType="submit"
        >
          <strong> Next </strong>
        </a-button>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'OtpConfirmation',
  data: function () {
    return {
      form: this.$form.createForm(this),
    }
  },
  methods: {
    resendEmail () {
      console.log('resend email')
    },
  },
  computed: {
    ...mapState(['settings', 'app']),
  },
}
</script>

<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>

<style lang="scss" scoped>
.logo {
  max-height: 75px;
  max-width: 200px;
}

input{
  width: 35px;
  height: 35px;
  padding: 0;
  margin-right: 25px;
  text-align: center;
  border: 1px solid gray;
  border-radius: 5px;
  &:last-child{
    margin-right: 0;
  }
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }
  &:focus,
  &.focus{
    border-color: green;
    outline: none;
    box-shadow: none;
  }
}

</style>
